<!--
  TypeElement.vue
  A chip for a record type: its icon and label. Reads them from `value`, the type
  as the catalog holds it; a bare type name shows as its own label.

  Props:
    - value: The type object (name, label, and `schema.icon`) or a type name
    - size: Chip size ('small', 'normal', 'medium', 'large')
  Note: This component never shows a delete button.
-->
<template>
  <div class="tags type-tag">
    <span class="tag tag-rounded bg-dark" :class="tagClass">
      <span class="icon pl-1 mr-1">
        <font-awesome-icon :icon="icon" />
      </span>
      <span class="pr-1">{{ label }}</span>
    </span>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { FALLBACK_RECORD_ICON } from "@auger/core/fields"

interface Props {
  value: Record<string, any> | string
  size?: string
}

const props = withDefaults(defineProps<Props>(), {
  size: "normal",
})

const type = computed(() => (typeof props.value === "string" ? null : props.value))
const label = computed(
  () => type.value?.label ?? type.value?.name ?? (props.value as string | undefined)
)
const icon = computed(() => type.value?.schema?.icon || FALLBACK_RECORD_ICON)

const tagClass = computed(() => ({
  [`is-${props.size}`]: props.size !== "normal",
  "text-inverted": true,
}))
</script>
